import { createContext } from 'react';
var defaultLanguageContextProps = {
  language: '',
  languageOnChangeCallback: undefined
};
var LanguageContext = createContext(defaultLanguageContextProps);
export var LanguageContextProvider = LanguageContext.Provider;
export var LanguageContextConsumer = LanguageContext.Consumer;
export default LanguageContext;